import { Injectable } from '@angular/core'

import { Action, TSP_RESOURCES } from '@ti/contracts'
import { BaseRolesListModel } from '@ti/shared/roles/models'

@Injectable()
export class TspRolesListModel extends BaseRolesListModel {
  public override defaultReturnRoute = 'users'
  protected readonly modelName = 'TspRolesListModel'

  public readonly allowedActions = [
    Action.View,
    Action.Create,
    Action.Update,
    Action.Delete,
    Action.Suspend,
    Action.LoginAs,
  ]

  public readonly allowedResources = TSP_RESOURCES
}
